/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable eqeqeq */

import moment from 'moment';

import * as Api from '../api';
import { SearchLimitPerPage, eventSearchLimitPerPage } from '../utils/search';
import {
    SEARCH_SET_TYPE_SORTING,
    SEARCH_TYPES,
    SEARCH_UPDATE_QUERY,
    SEARCH_UPDATE_FILTERS_APPLIED,
} from './actionTypes/search-action-types';

const EVENT_TYPE = 'events';
const PAID_HITS_TYPE = 'paidHits';
const FLEX_LEAGUES_TYPE = 'flexLeagues';
const PRO_TENNIS_TOUR_TYPE = 'proTennisTour';
const JUNIOR_CIRCUITS_TYPE = 'juniorCircuits';
const COLLEGE_CIRCUITS_TYPE = 'collegeCircuits';
const JUNIOR_REGIONALS_TYPE = 'juniorRegionals';
const validTypes = [
    EVENT_TYPE,
    PAID_HITS_TYPE,
    FLEX_LEAGUES_TYPE,
    PRO_TENNIS_TOUR_TYPE,
    JUNIOR_CIRCUITS_TYPE,
    COLLEGE_CIRCUITS_TYPE,
    JUNIOR_REGIONALS_TYPE,
];
const DEFAULT_SORT_DIRECTION = 'desc';

export function setSearchMode({ mode, lookupType, lookUpParams, lookupCount, lookup, displayText, allowInvite, displayFilters, gotoSearchResults, sportTypeId }) {
    return (dispatch) => {
        dispatch({ type: 'SEARCH:SET_SEARCH_MODE', params: { mode, lookupType, lookUpParams, lookupCount, lookup, displayText, allowInvite, displayFilters, gotoSearchResults, sportTypeId } });
    };
}

export function setSearchPageType({ searchPageType }) {
    return (dispatch) => {
        dispatch({ type: 'SEARCH:SET_SEARCHPAGE_TYPE', searchPageType });
    };
}

export function setTypeFilter(filter, reSearch) {
    return (dispatch) => {
        dispatch(clearFilters('everythingButType'));
        dispatch({ type: 'SEARCH:SET_TYPE_FILTER', filter });
        if (reSearch) {
            dispatch(search(null, 'searchPage'));
        }
    };
}

export function setGeoLocation(geocoded) {
    return (dispatch) => {
        dispatch({ type: 'SEARCH:SET_GEO_LOCATION', geocoded });
    };
}

export function updateQuery(query) {
    return (dispatch) => {
        dispatch({ type: SEARCH_UPDATE_QUERY, query });
        dispatch(updateQueryParams(true));
    };
}

export function updateQueryParams(bool) {
    return (dispatch) => {
        dispatch({ type: 'SEARCH:UPDATE_QUERY_PARAMS', updateQueryParams: bool });
    };
}

export function changeFilterInputs(filters) {
    return (dispatch) => {
        dispatch({ type: 'SEARCH:CHANGE_FILTER_INPUTS', filters });
    };
}

export function updateSportTypes(data) {
    return (dispatch) => {
        dispatch({ type: 'SEARCH:UPDATE_SPORT_TYPES', data });
    };
}

// School searches keep the Power6 sort initialized in initializeSchoolSorting (gate-aware,
// school.power6 vs activeRoster) so every school search carries an explicit sort;
// blanking it would let the server apply the wrong default field for high schools.
const SCHOOL_SEARCH_TYPES = [SEARCH_TYPES.COLLEGES, SEARCH_TYPES.HIGH_SCHOOLS];

function resetTypeSortingUnlessSchool(dispatch, filtersType) {
    if (filtersType && !SCHOOL_SEARCH_TYPES.includes(filtersType)) {
        dispatch({ type: 'SEARCH:SET_TYPE_SORTING', sort: { type: filtersType, field: '', direction: 'asc' } });
    }
}

export function updateFiltersApplied(reSearch, searchOrigin) {
    return (dispatch, getState) => {
        // reset sort order on filter change
        const { filters } = getState().search;
        resetTypeSortingUnlessSchool(dispatch, filters.type);
        dispatch({ type: SEARCH_UPDATE_FILTERS_APPLIED });
        if (reSearch) {
            // keep type filter set
            dispatch(search(null, searchOrigin));
            dispatch(updateQueryParams(true));
        }
    };
}

export function applySearchFilters(filters, reSearch, searchOrigin) {
    return (dispatch, getState) => {
        // reset sort order on filter change
        const state = getState().search;
        resetTypeSortingUnlessSchool(dispatch, state.filters.type);
        dispatch({ type: 'SEARCH:CHANGE_FILTER_INPUTS', filters });
        dispatch({ type: SEARCH_UPDATE_FILTERS_APPLIED });
        if (reSearch) {
            // keep type filter set
            dispatch(search(null, searchOrigin));
            dispatch(updateQueryParams(true));
        }
    };
}

export function undoFilterChange() {
    return (dispatch) => {
        dispatch({ type: 'SEARCH:UNDO_FILTER_CHANGE' });
    };
}

export function clearFilters(type, reSearch) {
    return (dispatch, getState) => {
        const searchState = getState().search;
        const { searchPageType, filters } = searchState;
        const { type: filterType, regionSearch, sportTypes: { tennis } } = filters;

        const everythingButType = {
            ageMin: '',
            ageMax: '',
            primaryTag: '',
            ageTag: '',
            college: '',
            division: '',
            conference: '',
            startDate: moment(),
            endDate: null,
            gender: '',
            genders: {},
            hsGradYears: {},
            distance: '',
            nationality: '',
            publicPrivate: '',
            utrMin: 1,
            utrMax: 16,
            utrType: 'verified',
            utrTeamType: tennis ? 'singles' : 'doubles',
            utrReliability: null,
            utrFitRating: '',
            utrFitPosition: '6',
            locationCountryName: '',
            locationStateName: '',
            hasPrizeMoney: null,
            eventTypes: {},
            eventRegions: {},
            eventUtrTypes: {},
            eventTeamTypes: {},
            prizeMoneyMin: null,
            prizeMoneyMax: null,
            entryFeeMin: null,
            entryFeeMax: null,
            eventTags: {},
            ballTypes: {},
            // regionSearch: (!isEmpty(eventRegions) && filterType == 'juniorCircuits') ? regionSearch : false,
            regionSearch: filterType == 'juniorCircuits' ? regionSearch : false,
            ...(searchPageType === 'search' ? { tours: {} } : {}),
        };

        switch (type) {
            case 'age':
                dispatch(applySearchFilters({
                    ageMin: '',
                    ageMax: '',
                }, reSearch));
                break;

            case 'colleges':
                dispatch(applySearchFilters({
                    college: '',
                    division: '',
                    conference: '',
                }, reSearch));
                break;

            case 'conference':
                dispatch(applySearchFilters({
                    conference: '',
                }, reSearch));
                break;

            case 'date':
                dispatch(applySearchFilters({
                    startDate: searchState.query && searchState.query.length > 0 ? null : moment(new Date()),
                    endDate: null,
                }, reSearch));
                break;

            case 'division':
                dispatch(applySearchFilters({
                    division: '',
                }, reSearch));
                break;

            case 'highSchool':
                dispatch(applySearchFilters({
                    hsGradYears: {},
                }, reSearch));
                break;

            case 'location':
                dispatch(applySearchFilters({
                    distance: '',
                    location: '',
                    locationInputValue: '',
                    lat: null,
                    lng: null,
                    locationCountryName: '',
                    locationStateName: '',
                }, reSearch));
                break;

            case 'nationality':
                dispatch(applySearchFilters({
                    nationality: '',
                }, reSearch));
                break;

            case 'primaryTag':
                dispatch(applySearchFilters({
                    primaryTag: '',
                }, true));
                break;

            case 'publicPrivate':
                dispatch(applySearchFilters({
                    publicPrivate: '',
                }, true));
                break;

            case 'type':
                dispatch(applySearchFilters({
                    type: '',
                }, reSearch));
                break;

            case 'utr':
                dispatch(applySearchFilters({
                    utrMin: 1,
                    utrMax: 16,
                    utrType: 'verified',
                    utrTeamType: 'singles',
                    utrReliability: null,
                }, reSearch));
                break;

            case 'utrFit':
                dispatch(applySearchFilters({
                    utrFitRating: '',
                    utrFitPosition: '6',
                }, reSearch));
                break;

            case 'proTennis':
                dispatch(applySearchFilters({
                    ...everythingButType,
                    tours: { 'UTR Pro Tennis Tour': true },
                }, reSearch));
                break;

            case 'everythingButType':
                dispatch(applySearchFilters(everythingButType, reSearch, 'searchPage'));
                break;

            case 'tours':
                dispatch(applySearchFilters({
                    tours: {},
                }, reSearch));
                break;

            case 'playersMore':
                dispatch(applySearchFilters({
                    gender: '',
                    utrMin: 1,
                    utrMax: 16,
                    utrType: 'verified',
                    utrTeamType: 'singles',
                    utrReliability: null,
                    nationality: '',
                    division: '',
                    conference: '',
                }, reSearch));
                break;

            case 'eventsMore':
                dispatch(applySearchFilters({
                    hasPrizeMoney: null,
                    eventTypes: {},
                    eventRegions: {},
                    eventUtrTypes: {},
                    prizeMoneyMin: null,
                    prizeMoneyMax: null,
                    entryFeeMin: null,
                    entryFeeMax: null,
                    utrMin: 1,
                    utrMax: 16,
                    eventTeamTypes: {},
                    genders: {},
                    ...(searchPageType === 'search' ? { tours: {} } : {}),
                }, reSearch));
                break;

            case 'collegesMore':
                dispatch(applySearchFilters({
                    division: '',
                    conference: '',
                    utrFitRating: '',
                    utrFitPosition: '6',
                }, reSearch));
                break;

            default:
                dispatch(applySearchFilters({
                    type: filters.type,
                    ...everythingButType,
                }, true));
                break;
        }
    };
}

export function setTypeSorting({ type, field, direction }) {
    return (dispatch) => {
        dispatch({ type: 'SEARCH:SET_TYPE_SORTING', sort: { type, field, direction } });
        switch (type) {
            case 'players':
                dispatch(loadPlayers({ newSearch: true }));
                break;
            case 'events':
                dispatch(loadEvents({ newSearch: true }));
                break;
            case 'clubs':
                dispatch(loadClubs({ newSearch: true }));
                break;
            case 'colleges':
                dispatch(loadColleges({ newSearch: true }));
                break;
            case 'highSchools':
                dispatch(loadHighSchools({ newSearch: true }));
                break;
            case 'adultTeamClubs':
                dispatch(loadAdultTeamClubs({ newSearch: true }));
                break;
            case 'paidHitClubs':
                dispatch(loadPaidHitClubs({ newSearch: true }));
                break;
            default:
                break;
        }
        dispatch(updateQueryParams(true));
    };
}

export function initializeSchoolSorting(collegeSortField, highSchoolSortField) {
    return (dispatch) => {
        dispatch({ type: SEARCH_SET_TYPE_SORTING, sort: { type: SEARCH_TYPES.COLLEGES, field: collegeSortField, direction: DEFAULT_SORT_DIRECTION } });
        dispatch({ type: SEARCH_SET_TYPE_SORTING, sort: { type: SEARCH_TYPES.HIGH_SCHOOLS, field: highSchoolSortField, direction: DEFAULT_SORT_DIRECTION } });
    };
}

export function setLoadingFlag() {
    return (dispatch) => {
        dispatch({ type: 'SEARCH:SET_LOADING_FLAG' });
    };
}

export function search(resetTypeFilter, searchOrigin) {
    return (dispatch, getState, { mainApi }) => {
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters } = searchState;
        const searchParams = { query, filters };

        if (filters.type) {
            searchParams.appendType = true;
            if (searchState[filters.type]?.sort?.field) {
                searchParams.sort = searchState[filters.type].sort;
            }
        }
        dispatch({ type: 'SEARCH:FETCH_REQUEST' });
        Api.search(mainApi, coreUI, searchParams, searchOrigin)
            .then((result) => {
                const { data } = result;

                if (data.error) {
                    dispatch({ type: 'SEARCH:FETCH_FAILURE', data });
                } else {
                        dispatch({ type: 'SEARCH:FETCH_SUCCESS', data, typeFilter: filters.type || null });
                    if (resetTypeFilter) {
                        dispatch({ type: 'SEARCH:RESET_TYPE_FILTER' });
                    }
                }
            })
            .catch((error) => {
                dispatch({ type: 'SEARCH:FETCH_FAILURE' });
            });
        // }
    };
}

export function clearGlobalSearch(clear) {
    return (dispatch) => {
        dispatch({ type: 'SEARCH:CLEAR_GLOBAL_SEARCH', clearGlobalSearch: clear });
    };
}

export function expandSearch(isExpanded) {
    return (dispatch) => {
        dispatch({ type: 'SEARCH:EXPAND_SEARCH', isExpanded });
    };
}

export function storeResults(query, results, resetTypeFilter) {
    return (dispatch, getState) => {
        const { filters } = getState().search;
        const filtersAreActive = (filters.utrMin > 1 || filters.utrMax < 16 || filters.gender || (filters.startDate && moment(filters.startDate).diff(new Date(), 'days') != 0) || filters.endDate || (filters.lat && filters.lng && filters.distance) || (filters.locationCountryName || filters.locationStateName) || filters.college || filters.division || filters.conference || filters.utrFitRating || filters.publicPrivate || filters.nationality || filters.ageMin || filters.ageMax || filters.hasPrizeMoney);
        // if filters are already set, make a new search for showing filtered results on main search page
        if (filtersAreActive) {
            // update query string
            dispatch({ type: SEARCH_UPDATE_QUERY, query });
            if (resetTypeFilter) {
                dispatch({ type: 'SEARCH:RESET_TYPE_FILTER' });
            }
            // redo search with existing filters
            // dispatch(search(true));
            dispatch(search(null, 'searchPage'));
        } else {
            // otherwise load the typeahead results into the search page to view all..
            dispatch({ type: 'SEARCH:STORE_RESULTS', query, results });
        }
    };
}

export function loadPlayers({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_PLAYERS_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, players } = searchState;
        const { top, skip } = players;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (players.sort.field) {
            searchParams.sort = players.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_PLAYERS_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_PLAYERS_SUCCESS', data, skip: newSearch ? SearchLimitPerPage : skip + SearchLimitPerPage });
                }
            })
            .catch((error) => {
                dispatch({ type: 'SEARCH:LOAD_PLAYERS_FAILURE' });
            });
    };
}

export function loadClubs({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_CLUBS_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, clubs } = searchState;
        const { top, skip } = clubs;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (clubs.sort.field) {
            searchParams.sort = clubs.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_CLUBS_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_CLUBS_SUCCESS', data, skip: newSearch ? SearchLimitPerPage : skip + SearchLimitPerPage });
                }
            })
            .catch((error) => {
                dispatch({ type: 'SEARCH:LOAD_CLUBS_FAILURE' });
            });
    };
}

export function loadEvents({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_EVENTS_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, events } = searchState;

        const { top, skip } = events;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (events.sort.field) {
            searchParams.sort = events.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_EVENTS_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_EVENTS_SUCCESS', data, skip: newSearch ? eventSearchLimitPerPage : skip + eventSearchLimitPerPage });
                }
            })
            .catch((error) => {
                dispatch({ type: 'SEARCH:LOAD_EVENTS_FAILURE' });
            });
    };
}

export function loadFlexLeagues({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_FLEX_LEAGUES_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, flexLeagues } = searchState;

        const { top, skip } = flexLeagues;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (flexLeagues.sort.field) {
            searchParams.sort = flexLeagues.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_FLEX_LEAGUES_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_FLEX_LEAGUES_SUCCESS', data, skip: newSearch ? eventSearchLimitPerPage : skip + eventSearchLimitPerPage });
                }
            })
            .catch((error) => {
                dispatch({ type: 'SEARCH:LOAD_FLEX_LEAGUES_FAILURE' });
            });
    };
}

export function loadTeamLeagues({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_TEAM_LEAGUES_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, teamLeagues } = searchState;
        const { top, skip } = teamLeagues;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (teamLeagues.sort.field) {
            searchParams.sort = teamLeagues.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_TEAM_LEAGUES_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_TEAM_LEAGUES_SUCCESS', data, skip: newSearch ? SearchLimitPerPage : skip + SearchLimitPerPage });
                }
            })
            .catch((error) => {
                dispatch({ type: 'SEARCH:LOAD_TEAM_LEAGUES_FAILURE' });
            });
    };
}

export function loadProTennisTourEvents({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_PRO_TENNIS_TOUR_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, proTennisTour } = searchState;
        const { top, skip } = proTennisTour;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (proTennisTour.sort.field) {
            searchParams.sort = proTennisTour.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_PRO_TENNIS_TOUR_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_PRO_TENNIS_TOUR_SUCCESS', data, skip: newSearch ? eventSearchLimitPerPage : skip + eventSearchLimitPerPage });
                }
            })
            .catch((error) => {
                dispatch({ type: 'SEARCH:LOAD_PRO_TENNIS_TOUR_FAILURE' });
            });
    };
}

export function loadPaidHitEvents({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_PAID_HITS_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, paidHits } = searchState;

        const { top, skip } = paidHits;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (paidHits.sort.field) {
            searchParams.sort = paidHits.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_PAID_HITS_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_PAID_HITS_SUCCESS', data, skip: newSearch ? eventSearchLimitPerPage : skip + eventSearchLimitPerPage });
                }
            })
            .catch(() => {
                dispatch({ type: 'SEARCH:LOAD_PAID_HITS_FAILURE' });
            });
    };
}

export function loadJuniorCircuits({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_JUNIOR_CIRCUITS_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, juniorCircuits } = searchState;

        const { top, skip } = juniorCircuits;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (juniorCircuits.sort.field) {
            searchParams.sort = juniorCircuits.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_JUNIOR_CIRCUITS_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_JUNIOR_CIRCUITS_SUCCESS', data, skip: newSearch ? eventSearchLimitPerPage : skip + eventSearchLimitPerPage });
                }
            })
            .catch(() => {
                dispatch({ type: 'SEARCH:LOAD_JUNIOR_CIRCUITS_FAILURE' });
            });
    };
}

export function loadCamps({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_CAMPS_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, camps } = searchState;
        const { top, skip } = camps;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (camps.sort.field) {
            searchParams.sort = camps.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_CAMPS_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_CAMPS_SUCCESS', data, skip: newSearch ? SearchLimitPerPage : skip + SearchLimitPerPage });
                }
            })
            .catch(() => {
                dispatch({ type: 'SEARCH:LOAD_CAMPS_FAILURE' });
            });
    };
}

export function loadCollegeCircuits({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_COLLEGE_CIRCUITS_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, collegeCircuits } = searchState;

        const { top, skip } = collegeCircuits;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (collegeCircuits.sort.field) {
            searchParams.sort = collegeCircuits.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_COLLEGE_CIRCUITS_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_COLLEGE_CIRCUITS_SUCCESS', data, skip: newSearch ? eventSearchLimitPerPage : skip + eventSearchLimitPerPage });
                }
            })
            .catch(() => {
                dispatch({ type: 'SEARCH:LOAD_COLLEGE_CIRCUITS_FAILURE' });
            });
    };
}

export function loadJuniorRegionals({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_JUNIOR_REGIONALS_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, juniorRegionals } = searchState;

        const { top, skip } = juniorRegionals;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (juniorRegionals.sort.field) {
            searchParams.sort = juniorRegionals.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_JUNIOR_REGIONALS_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_JUNIOR_REGIONALS_SUCCESS', data, skip: newSearch ? eventSearchLimitPerPage : skip + eventSearchLimitPerPage });
                }
            })
            .catch(() => {
                dispatch({ type: 'SEARCH:LOAD_JUNIOR_REGIONALS_FAILURE' });
            });
    };
}

export function loadHighSchools({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_HIGHSCHOOLS_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, highSchools } = searchState;
        const { top, skip } = highSchools;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (highSchools.sort.field) {
            searchParams.sort = highSchools.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_HIGHSCHOOLS_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_HIGHSCHOOLS_SUCCESS', data, skip: newSearch ? SearchLimitPerPage : skip + SearchLimitPerPage });
                }
            })
            .catch((error) => {
                dispatch({ type: 'SEARCH:LOAD_HIGHSCHOOLS_FAILURE' });
            });
    };
}

export function loadColleges({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_COLLEGES_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, colleges } = searchState;
        const { top, skip } = colleges;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (colleges.sort.field) {
            searchParams.sort = colleges.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_COLLEGES_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_COLLEGES_SUCCESS', data, skip: skip + SearchLimitPerPage });
                }
            })
            .catch((error) => {
                dispatch({ type: 'SEARCH:LOAD_COLLEGES_FAILURE' });
            });
    };
}

export function loadAdultTeamClubs({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_ADULT_TEAM_CLUBS_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, adultTeamClubs } = searchState;
        const { top, skip } = adultTeamClubs;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (adultTeamClubs.sort.field) {
            searchParams.sort = adultTeamClubs.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_ADULT_TEAM_CLUBS_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_ADULT_TEAM_CLUBS_SUCCESS', data, skip: newSearch ? SearchLimitPerPage : skip + SearchLimitPerPage });
                }
            })
            .catch((error) => {
                dispatch({ type: 'SEARCH:LOAD_ADULT_TEAM_CLUBS_FAILURE' });
            });
    };
}

export function loadPaidHitClubs({ newSearch } = {}) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SEARCH:LOAD_PAID_HIT_CLUBS_REQUEST', newSearch });
        const searchState = getState().search;
        const { coreUI } = getState();
        const { query, filters, paidHitClubs } = searchState;
        const { top, skip } = paidHitClubs;
        const searchParams = { query, filters, top, appendType: true, skip };

        if (paidHitClubs.sort.field) {
            searchParams.sort = paidHitClubs.sort;
        }

        Api.search(mainApi, coreUI, searchParams, 'searchPage')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SEARCH:LOAD_PAID_HIT_CLUBS_FAILURE', data });
                } else {
                    dispatch({ type: 'SEARCH:LOAD_PAID_HIT_CLUBS_SUCCESS', data, skip: newSearch ? SearchLimitPerPage : skip + SearchLimitPerPage });
                }
            })
            .catch((error) => {
                dispatch({ type: 'SEARCH:LOAD_PAID_HIT_CLUBS_FAILURE' });
            });
    };
}

// ExplorePage search actions

export function loadExplorePlayers({ gender, lat, lng }) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'EXPLORE:LOAD_PLAYERS_REQUEST' });
        const { coreUI } = getState();
        const searchParams = {
            filters: {
                type: 'players',
                distance: '50mi',
                lat,
                lng,
                gender: gender || 'M',
            },
            appendType: true,
            top: 3,
            skip: 0,
        };

        Api.search(mainApi, coreUI, searchParams, null, 'players')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'EXPLORE:LOAD_PLAYERS_FAILURE', data });
                } else if (!data.total) {
                    dispatch({ type: 'EXPLORE:NO_LOCAL_PLAYERS', noLocalPlayers: true });
                    dispatch(loadExplorePlayers({}));
                } else {
                    dispatch({ type: 'EXPLORE:LOAD_PLAYERS_SUCCESS', data });
                }
            })
            .catch((error) => {
                dispatch({ type: 'EXPLORE:LOAD_PLAYERS_FAILURE' });
            });
    };
}

export function loadExploreEvents({ lat, lng }) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'EXPLORE:LOAD_EVENTS_REQUEST' });
        const { coreUI } = getState();
        const searchParams = {
            filters: {
                type: 'events',
                distance: '50mi',
                lat,
                lng,
            },
            appendType: true,
            top: 3,
            skip: 0,
        };

        Api.search(mainApi, coreUI, searchParams, null, 'events')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'EXPLORE:LOAD_EVENTS_FAILURE', data });
                } else if (!data.total) {
                    dispatch({ type: 'EXPLORE:NO_LOCAL_EVENTS', noLocalEvents: true });
                    dispatch(loadExploreEvents({}));
                } else {
                    dispatch({ type: 'EXPLORE:LOAD_EVENTS_SUCCESS', data });
                }
            })
            .catch((error) => {
                dispatch({ type: 'EXPLORE:LOAD_EVENTS_FAILURE' });
            });
    };
}

export function loadExploreColleges() {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'EXPLORE:LOAD_COLLEGES_REQUEST' });
        const { coreUI } = getState();
        const searchParams = {
            filters: {
                type: 'colleges',
            },
            appendType: true,
            top: 3,
            skip: 0,
        };

        Api.search(mainApi, coreUI, searchParams, null, 'colleges')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'EXPLORE:LOAD_COLLEGES_FAILURE', data });
                } else if (!data.total) {
                    dispatch({ type: 'EXPLORE:NO_LOCAL_COLLEGES', noLocalColleges: true });
                } else {
                    dispatch({ type: 'EXPLORE:LOAD_COLLEGES_SUCCESS', data });
                }
            })
            .catch((error) => {
                dispatch({ type: 'EXPLORE:LOAD_COLLEGES_FAILURE' });
            });
    };
}

export function loadExploreHighSchools() {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'EXPLORE:LOAD_HIGH_SCHOOLS_REQUEST' });
        const { coreUI } = getState();
        const searchParams = {
            filters: {
                type: 'highSchools',
            },
            appendType: true,
            top: 3,
            skip: 0,
        };

        Api.search(mainApi, coreUI, searchParams, null, 'highSchools')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'EXPLORE:LOAD_HIGH_SCHOOLS_FAILURE', data });
                } else if (!data.total) {
                    dispatch({ type: 'EXPLORE:NO_LOCAL_HIGH_SCHOOLS', noLocalHighSchools: true });
                } else {
                    dispatch({ type: 'EXPLORE:LOAD_HIGH_SCHOOLS_SUCCESS', data });
                }
            })
            .catch((error) => {
                dispatch({ type: 'EXPLORE:LOAD_COLLEGES_FAILURE' });
            });
    };
}

export const fetchPrismicContent = () => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'SEARCH:FETCH_PRISMIC_CONTENT_REQUEST' });
    try {
        const res = await mainApi.get('v1/content/fetchsearchcontent');
        const { data } = res;
        if (data.error) {
            dispatch({ type: 'SEARCH:FETCH_PRISMIC_CONTENT_FAILURE', data: data.error });
        } else {
            dispatch({ type: 'SEARCH:FETCH_PRISMIC_CONTENT_SUCCESS', data });
        }
    } catch (error) {
        dispatch({ type: 'SEARCH:FETCH_PRISMIC_CONTENT_FAILURE', data: error });
    }
};

// Get paid hits for home dash feed
export const getPaidHits = (filters) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'HOMEPAGE_CONTENT:GET_PAID_HITS' });
    try {
        const { coreUI } = getState();
        const { location, lat, lng, utrMin = 1, utrMax = 16, distance } = filters;
        const searchParams = {
            filters: {
                type: 'paidHits',
                startDate: moment(new Date()),
                distance,
                location,
                lat,
                lng,
                utrMin,
                utrMax,
            },
            appendType: true,
            top: 3,
            skip: 0,
        };

        Api.search(mainApi, coreUI, searchParams, null, 'paidHits')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_PAID_HITS_FAILURE', payload: data.error });
                } else {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_PAID_HITS_SUCCESS', payload: data.hits });
                }
            })
            .catch((error) => {
                dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_PAID_HITS_FAILURE', payload: error });
            });
    } catch (error) {
        dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_PAID_HITS_FAILURE', payload: error });
    }
};

// Get paid hit clubs for home dash feed
export const getPaidHitClubs = (filters) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'HOMEPAGE_CONTENT:GET_PAID_HIT_CLUBS' });
    try {
        const { coreUI } = getState();
        const { location, lat, lng, distance } = filters;
        const searchParams = {
            filters: {
                type: 'paidHitClubs',
                distance,
                location,
                lat,
                lng,
            },
            appendType: true,
            top: 3,
            skip: 0,
        };

        Api.search(mainApi, coreUI, searchParams, null, 'paidHitClubs')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_PAID_HIT_CLUBS_FAILURE', payload: data.error });
                } else {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_PAID_HIT_CLUBS_SUCCESS', payload: data.hits });
                }
            })
            .catch((error) => {
                dispatch({ type: 'HOMEPAGE_CONTENT:GET_PAID_HIT_CLUBS_FAILURE', payload: error });
            });
    } catch (error) {
        dispatch({ type: 'HOMEPAGE_CONTENT:GET_PAID_HIT_CLUBS_FAILURE', payload: error });
    }
};

export const getEventsNearMe = (filters) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'HOMEPAGE_CONTENT:GET_EVENTS_NEAR_ME' });
    try {
        const { coreUI } = getState();
        const { location, lat, lng, utrMin = 1, utrMax = 16, distance, sportTypes, ballTypes } = filters;
        const searchParams = {
            filters: {
                type: 'events',
                startDate: moment(new Date()),
                distance,
                location,
                lat,
                lng,
                utrMin,
                utrMax,
                sportTypes,
                ballTypes,
            },
            appendType: true,
            top: 3,
            skip: 0,
        };
        Api.search(mainApi, coreUI, searchParams, null, 'eventsNearMe')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_EVENTS_NEAR_ME_FAILURE', payload: data.error });
                } else {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_EVENTS_NEAR_ME_SUCCESS', payload: data.hits });
                }
            })
            .catch((error) => {
                dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_EVENTS_NEAR_ME_FAILURE', payload: error });
            });
    } catch (error) {
        dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_EVENTS_NEAR_ME_FAILURE', payload: error });
    }
};

// Get local players for home dash feed
export const getLocalPlayers = (filters) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'HOMEPAGE_CONTENT:GET_LOCAL_PLAYERS' });
    try {
        const { coreUI } = getState();
        const { location, lat, lng, utrMin = 1, utrMax = 16, distance, gender } = filters;
        const searchParams = {
            filters: {
                type: 'players',
                startDate: moment(new Date()),
                distance,
                location,
                lat,
                lng,
                utrMin,
                utrMax,
                gender,
            },
            appendType: true,
            top: 6,
            skip: 0,
        };

        Api.search(mainApi, coreUI, searchParams, null, 'players')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_LOCAL_PLAYERS_FAILURE', payload: data.error });
                } else {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_LOCAL_PLAYERS_SUCCESS', payload: data.hits });
                }
            })
            .catch((error) => {
                dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_LOCAL_PLAYERS_FAILURE', payload: error });
            });
    } catch (error) {
        dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_LOCAL_PLAYERS_FAILURE', payload: error });
    }
};

export const getDashboardColleges = (filters) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'HOMEPAGE_CONTENT:GET_COLLEGES' });
    try {
        const { coreUI } = getState();
        const { location, lat, lng, utrMin = 1, utrMax = 16, distance, gender } = filters;
        const searchParams = {
            filters: {
                type: 'colleges',
                startDate: moment(new Date()),
                distance,
                location,
                lat,
                lng,
                utrMin,
                utrMax,
                gender,
            },
            appendType: true,
            top: 3,
            skip: 0,
        };

        Api.search(mainApi, coreUI, searchParams, null, 'colleges')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_COLLEGES_FAILURE', payload: data.error });
                } else {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_COLLEGES_SUCCESS', payload: data.hits });
                }
            })
            .catch((error) => {
                dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_COLLEGES_FAILURE', payload: error });
            });
    } catch (error) {
        dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_COLLEGES_FAILURE', payload: error });
    }
};

export const getDashboardHighSchools = (filters) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'HOMEPAGE_CONTENT:GET_HIGH_SCHOOLS' });
    try {
        const { coreUI } = getState();
        const { location, lat, lng, utrMin = 1, utrMax = 16, distance, gender } = filters;
        const searchParams = {
            filters: {
                type: 'highSchools',
                startDate: moment(new Date()),
                distance,
                location,
                lat,
                lng,
                utrMin,
                utrMax,
                gender,
            },
            appendType: true,
            top: 3,
            skip: 0,
        };

        Api.search(mainApi, coreUI, searchParams, null, 'highSchools')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_HIGH_SCHOOLS_FAILURE', payload: data.error });
                } else {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_HIGH_SCHOOLS_SUCCESS', payload: data.hits });
                }
            })
            .catch((error) => {
                dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_HIGH_SCHOOLS_FAILURE', payload: error });
            });
    } catch (error) {
        dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_HIGH_SCHOOLS_FAILURE', payload: error });
    }
};

export const getPlayerCreatedPlays = (filters) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'HOMEPAGE_CONTENT:GET_CREATE_PLAYS' });
    try {
        const { coreUI } = getState();
        const { location, lat, lng, distance, gender, sportTypes } = filters;
        const searchParams = {
            filters: {
                type: 'events',
                eventTypes: { group_play: true },
                startDate: moment(new Date()),
                distance,
                location,
                lat,
                lng,
                gender,
                sportTypes,
            },
            appendType: true,
            top: 3,
            skip: 0,
        };

        Api.search(mainApi, coreUI, searchParams, null, 'groupPlayEvents')
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_CREATE_PLAYS_FAILURE', payload: data.error });
                } else {
                    dispatch({ type: 'HOMEPAGE_CONTENT:GET_CREATE_PLAYS_SUCCESS', payload: data.hits });
                }
            })
            .catch((error) => {
                dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_CREATE_PLAYS_FAILURE', payload: error });
            });
    } catch (error) {
        dispatch({ type: 'EXHOMEPAGE_CONTENT:GET_CREATE_PLAYS_FAILURE', payload: error });
    }
};
